<template>
  <div class="back-to-top" v-if="isVisible" @click="scrollToTop">
    <i class="el-icon-caret-top" color="#3c427c"></i>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isVisible: false
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      this.isVisible = window.pageYOffset > 200
    },
    scrollToTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>
<style scoped>
.back-to-top {
  position: fixed;
  bottom: 100px;
  right: 150px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
  color: #3c427c;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  border-radius: 50%;
  background-color: #fff;
}
.back-to-top:hover {
  background-color: #f2f6fc;
}
.fa-chevron-up {
  font-size: 20px;
}
</style>
